import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BaseService } from '../../service/BaseService.service';
import { Router } from '@angular/router';
import { Constants } from '../../service/constants';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-slidebar',
    imports: [RouterLink, CommonModule],
    templateUrl: './slidebar.component.html',
    styleUrl: './slidebar.component.scss'
})
export class SlidebarComponent {

    constructor(public baseService: BaseService, private router: Router) { }

    goDashboard() {
        this.baseService.GetAuth('/user/validate-token').subscribe({
            next: (response) => {
                if (response.status == 401 || response.status == 403) {
                    this.baseService.Logout();
                   }
                if(response.success){
                    if(response.data.user.role_id == 1){
                        // Admin - stay on home page with full access
                        this.router.navigate(['/']);
                    } else if(response.data.user.role_id == 2){
                        this.router.navigate(['/dashboard-user']);
                    } else if(response.data.user.role_id == 3){
                        this.router.navigate(['/dashboard-expert']);
                    } else {
                        // Unknown role - redirect to home
                        this.router.navigate(['/']);
                    }
                }
            },
            error: (error) => {
                console.error('Token validation failed:', error);
                // If token validation fails, redirect to home
                this.router.navigate(['/']);
            }
        });
    }

    logout() {
        // Clear user data from localStorage
        localStorage.removeItem('AuthData');

        // Reset login status
        this.baseService.IsUserLoggedIn = false;

        // Show success message
        Swal.fire({
            title: 'Logged Out!',
            text: 'You have been successfully logged out.',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
        }).then(() => {
            // Redirect to home page
            this.router.navigate(['/']);
        });
    }

    // Close mobile menu
    closeMobileMenu() {
        const menuWrapper = document.querySelector('.ht-menu-wrapper');
        if (menuWrapper) {
            menuWrapper.classList.remove('ht-body-visible');
        }
    }
}
